
export function HomeIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M14 2h-4v2H8v2H6v2H4v2H2v2h2v10h7v-6h2v6h7V12h2v-2h-2V8h-2V6h-2V4h-2zm0 2v2h2v2h2v2h2v2h-2v8h-3v-6H9v6H6v-8H4v-2h2V8h2V6h2V4z"
      ></path>
    </svg>
  )
}
export function PlusIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path fill="currentColor" d="M11 4h2v7h7v2h-7v7h-2v-7H4v-2h7z"></path>
    </svg>
  )
}
export function GamepadIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 5h20v14H2zm18 12V7H4v10zM8 9h2v2h2v2h-2v2H8v-2H6v-2h2zm6 0h2v2h-2zm4 4h-2v2h2z"
      ></path>
    </svg>
  )
}
export function ClockIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M19 3H5v2H3v14h2v2h14v-2h2V5h-2zm0 2v14H5V5zm-8 2h2v6h4v2h-6z"
      ></path>
    </svg>
  )
}

export function CornerDownRightIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M6 16h10v2h2v-2h2v-2h-2v-2h-2v2H6V4H4v12zm10-4v-2h-2v2zm0 6v2h-2v-2z"
      ></path>
    </svg>
  )
}
export function CornerLeftUpIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M8 18V8H6V6h2V4h2v2h2v2h-2v10h10v2H8zm4-10h2v2h-2zM6 8H4v2h2z"
      ></path>
    </svg>
  )
}
export function ImageGalleryIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M2 2h20v16h-5v2h-2v-2H9v2H7v-2H2zm5 18v2H5v-2zm10 0v2h2v-2zm3-16H4v12h16zm-8 4h2v2h-2zm-2 4v-2h2v2zm0 0v2H8v-2zm6 0h-2v-2h2zm0 0h2v2h-2zM8 6H6v2h2z"
      ></path>
    </svg>
  )
}

export function ChevronUpIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <path
        fill="currentColor"
        d="M7 16H5v-2h2v-2h2v-2h2V8h2v2h2v2h2v2h2v2h-2v-2h-2v-2h-2v-2h-2v2H9v2H7z"
      ></path>
    </svg>
  )
}

export function LeaderboardIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" shapeRendering="crispEdges" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2 1h2v2h2v3h2v3h2V2h1V1h3v1h1v7h2V6h2V3h1V1h2v2h1v15h-1v1h1v3h-1v1H2v-1H1v-3h1v-1H1V3h1Z M2 3h2v5h2v3h2v2h2v-3h1V3h3v7h1v3h2v-2h2V8h1V3h2v14H2Z M2 19h20v3H2Z"
      />
    </svg>
  );
}
